export default {
  campaign_code_pdf: {
    start: 'Comienza {{START-DATE}}',
    share: '¡Comparte tu impacto con nosotros!',
  },
  section_terms: {
    building: 'edificio |||| edificios',
    department: 'departamento |||| departamentos',
    discipline: 'disciplina |||| disciplinas',
    faculty: 'facultad |||| facultades',
    school: 'escuela |||| escuelas',
    area: 'área |||| áreas',
    city: 'ciudad |||| ciudades',
    municipality: 'municipio |||| municipios',
    county: 'provincia |||| provincias',
    county_municipality: 'provincia |||| provincias',
    country: 'país |||| países',
    section: 'sección |||| secciones',
  },
};
